import { GTM_ID } from '../../../configurations/gtm';

export function trackCustomEvent(event: CustomTrackEvent) {
    if (typeof window === 'undefined') {
        return;
    }
    window.dataLayer.push(event);
}

export function pushToDataLayer(data: Record<string, unknown>) {
    if (typeof window === 'undefined') {
        return;
    }
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    window.dataLayer.push(data);
}

type CustomTrackEvent = {
    event: string;
    ecommerceGA: string;
    transaction: Record<string, unknown>;
    eventCallback: () => NodeJS.Timeout;
    eventTimeout: number;
};

export function getGTMId() {
    return GTM_ID;
}
